import React, { useState } from 'react';
import { Row } from 'react-bootstrap';


function Qa_Card(props) {
    const [answer, setanswer] = useState();

    function submitAnswer(qid) {
        let data = {
            "qid": qid,
            "answer": answer
        }
        props.callbackAnswer(data)
    }

    return (
        <>
            <Row className=" card card1 m-1 d-flex py-2" key={props.id}>
                <div className="col-3"><img src = {"https://s3.toolsvilla.com/" + props.img} className="col3"></img></div>
                <div className="col-8 w-75">

                    <span className="fs-14 theme-col f-600" >{props.productName}</span>
                    <p className="theme-col mb-0  fs-14 f-500">SKU : {props.SKU}</p>

                </div>
                <div className="col-12 ">
                    <p className="gry fs-13 f-500 mb-0">Question : {props.question}
                    </p>

                </div>

                <p />
                {props.answer ? <span>{props.answer}</span> :
                    <div class="clickToShowInfo">
                        <div class="info">
                            <form className="d-flex">

                                {/* <input type="textarea" name="textarea" className="in-hit fs-12" placeholder="Write your ans here...." /> */}
                                <textarea className="in-hit fs-12" value={answer} onChange={(e) => setanswer(e.target.value)}>
                                    Write your ans here....
                                </textarea>
                                <input type="button" value="Submit" onClick={() => submitAnswer(props.Qid)} className="sub-mit" />
                            </form>
                        </div>
                        <span className="ans fs-14" onClick={() => setanswer()}>ANSWER THIS QUESTION</span>
                    </div>}

                <p />


            </Row>
        </>
    )

}




export default Qa_Card